"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developmentFrameLoginLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const developmentTools_1 = require("../../developmentTools");
const frameLoginLoader_1 = require("../../appLoaders/frameLoginLoader");
const developmentFrameLoginLoader = params => {
    const newProps = {
        ...params,
        developerTools: (0, jsx_runtime_1.jsx)(developmentTools_1.DevelopmentModal, {}),
    };
    (0, frameLoginLoader_1.loginLoader)(newProps);
};
exports.developmentFrameLoginLoader = developmentFrameLoginLoader;
//# sourceMappingURL=developmentFrameLoginLoader.js.map